export const commonInputSx = {
  '& label:not(.MuiInputLabel-shrink)': {
    lineHeight: '16px',
  },

  '& label.MuiInputLabel-root': {
    fontSize: '16px',
    fontFamily: 'Segoe-UI-VF',
    color: '#8C8C8C',
    fontWeight: 500,
    zIndex: 0,
  },

  '& .MuiOutlinedInput-root': {
    height: '50px',
    alignItems: 'center',
    borderRadius: '8px',

    '& fieldset': {
      borderWidth: 1.25,
      borderColor: '#8C8C8C',
    },

    '&.Mui-focused fieldset': {
      borderWidth: 1.25,
      borderColor: '#8C8C8C',
    },
  },

  '& .MuiOutlinedInput-input': {
    height: '100%',
    fontSize: '16px',
    fontFamily: 'Segoe-UI-VF',
    color: '#000000',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',

    '&::placeholder': {
      fontSize: '14px',
      color: '#BFBFBF',
      opacity: 1,
    },

    '&.Mui-disabled': {
      opacity: 0.6,
    },
  },
};
